//import React from "react";

const ExportButton = ({ reportUrl, filterState, fileName = "report.csv" }) => {
  const Token = localStorage.getItem("_ux98c_v1");
  const handleExport = async () => {
    // console.log(filterState);
    try {
      const queryParams = new URLSearchParams(filterState).toString();
      const urlWithFilters = `${reportUrl}?${queryParams}`;

      const response = await fetch(urlWithFilters, {
        method: "GET",
        headers: {
          "Content-Type": "application/octet-stream",
          Authorization: `Bearer ${Token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to export");

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      // link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  return (
    <button className="btn btn-md btn-primary" onClick={handleExport}>
      Export List
    </button>
  );
};

export default ExportButton;
